import { Component, OnInit } from '@angular/core';
import { CollectionsService } from '../../../../services/collections.service';
import { CollectionsV2Service } from '../../../../services/collectionsV2.service';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { TranslateService } from '@ngx-translate/core';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Router } from '@angular/router';
import { NewJobcardService } from '../../../../services/new-jobcard.service';

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss'],
})
export class CollectionsComponent implements OnInit {
  public collectionServicesList: any = [];
  public loading = false;

  public loadingPartners = false;
  public linkedPartners: any = [];
  public selectedPartners: any = [];
  public selectedPartnerIds: any = [];

  public date = moment();
  public tab = 'Collections';
  public partnerID: number = 0;
  public columns: any = [
    {
      header: this.translate.instant('general.jobcard_no'),
      field: 'jobCardNo',
      type: 'jobcardno',
    },
    {
      header: this.translate.instant('bikeshop.collections.address'),
      field: 'fullAddress',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.name'),
      field: 'customer',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.contact_details'),
      field: 'phoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.bike_model'),
      field: 'bikeModel',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.customer_notes'),
      field: 'notes',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.date'),
      field: 'scheduleDate',
      type: 'date',
    },
    {
      header: this.translate.instant('bikeshop.collections.time'),
      field: 'timeSlot',
      type: 'time',
    },
    {
      header: this.translate.instant('bikeshop.collections.collected'),
      field: 'Collected',
      type: 'action',
    },
  ];
  public duration = 'Week';
  startWeek = moment().startOf('week');
  endWeek = moment().endOf('week');
  configured: boolean = false;
  checkingConfiguration: boolean = false;
  public countryData: any = {};

  constructor(
    public router: Router,
    public collectionService: CollectionsService,
    public collectionsV2Service: CollectionsV2Service,
    private translate: TranslateService,
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    private serviceRequest: ServiceRequestService,
    public modalService: NgbModal,
    public newJobcardService: NewJobcardService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();

    if (this.helpersService.getPartnerData().Country === 'GB') {
      this.columns.splice(2, 0, {
        header: this.translate.instant('bikeshop.collections.postal_code'),
        field: 'postalCode',
        type: 'string',
      });
    }
  }

  ngOnInit() {
    this.selectedPartnerIds = [this.partnerID];
    this.countryData = this.helpersService.getCountryData();
    this.checkConfiguration();
    this.getData();
    this.getLinkedEnabledPartners();
  }

  getLinkedEnabledPartners() {
    this.loadingPartners = true;
    this.collectionsV2Service
      .getEnabledLinkedPartners(this.partnerID)
      .subscribe(
        (res) => {
          console.log(res);
          this.linkedPartners = res;
          this.loadingPartners = false;

          this.selectedPartners.push(
            this.linkedPartners.find((y) => y.partnerID == this.partnerID),
          );

          if (this.linkedPartners.length > 1) {
            this.columns.unshift({
              header: this.translate.instant(
                'bikeshop.shop_profile.collections.store_name',
              ),
              field: 'store',
              type: 'string',
            });
          }
        },
        (err) => {
          this.loadingPartners = false;
        },
      );
  }

  checkConfiguration() {
    this.checkingConfiguration = true;
    this.partnerService
      .getPartnerDetail(this.helpersService.getPartnerId())
      .subscribe(
        (partner) => {
          if (partner.OffersCollections || partner.OffersDropOffs) {
            this.configured = true;
          }
          this.checkingConfiguration = false;
        },
        (error) => {
          this.checkingConfiguration = false;
        },
      );
  }

  goToConfiguration() {
    this.router.navigateByUrl('/store/pick-ups-delivery-setup');
  }

  changeTab(e) {
    if (e.index) {
      this.tab = 'DropOff';
      this.getData();
    } else {
      this.tab = 'Collections';
      this.getData();
    }
  }

  setCollected(service) {
    if (this.tab === 'Collections') {
      this.collectionService
        .putCollected(service.serviceID || service.id, service.collected)
        .subscribe((res) => console.log(res));
    } else {
      this.collectionService
        .putDroppedOff(service.serviceID || service.id, service.collected)
        .subscribe((res) => console.log(res));
    }
  }

  increaseDate() {
    if (this.duration === 'Day') {
      this.date = this.date.add(1, 'days');
      this.getData();
    } else {
      this.startWeek.add(1, 'week').startOf('week');
      this.endWeek.add(1, 'week').endOf('week');
      this.getData();
    }
  }

  decreaseDate() {
    if (this.duration === 'Day') {
      this.date = this.date.subtract(1, 'days');
      this.getData();
    } else {
      this.startWeek.subtract(1, 'week').startOf('week');
      this.endWeek.subtract(1, 'week').endOf('week');
      this.getData();
    }
  }

  getData() {
    this.loading = true;
    if (this.tab === 'Collections') {
      this.collectionService
        .getCollections(
          this.duration === 'Week'
            ? this.startWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.duration === 'Week'
            ? this.endWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.selectedPartnerIds.join(','),
        )
        .subscribe(
          (res) => {
            this.collectionServicesList = res;
            this.collectionServicesList = this.collectionServicesList.map(
              (x) => {
                return { ...x, collected: x.statusID === 10 ? 1 : 0 };
              },
            );
            console.log();
            this.loading = false;
          },
          (err) => {
            this.collectionServicesList = [];
            this.loading = false;
          },
        );
    } else {
      this.collectionService
        .getDropOffs(
          this.duration === 'Week'
            ? this.startWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.duration === 'Week'
            ? this.endWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.selectedPartnerIds.join(','),
        )
        .subscribe(
          (res) => {
            this.collectionServicesList = res;
            this.collectionServicesList = this.collectionServicesList.map(
              (x) => {
                return { ...x, collected: x.statusID === 20 ? 1 : 0 };
              },
            );
            this.loading = false;
          },
          (err) => {
            this.collectionServicesList = [];
            this.loading = false;
          },
        );
    }
  }

  print() {
    // this.router.navigateByUrl("print-deliveries", {
    //   state: {
    //     collectionServicesList: this.collectionServicesList,
    //     date: this.date.format("ll") + "",
    //     type: this.tab,
    //   },
    // });

    console.log(this.selectedPartnerIds);

    var win = window.open(
      `/print-deliveries?Type=${this.tab}&StartDate=${this.duration === 'Week' ? this.startWeek.format('YYYY-MM-DD') : this.date.format('YYYY-MM-DD')}&EndDate=${this.duration === 'Week' ? this.endWeek.format('YYYY-MM-DD') : this.date.format('YYYY-MM-DD')}&Partners=${this.selectedPartnerIds.join(',')}`,
      '_blank',
    );
    win.focus();
  }

  changeDuration(duration) {
    this.duration = duration;
    this.getData();
  }

  openJobCard(jobcardID) {

    if (this.helpersService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => { 
          this.getData();
        }
      });

      return;
    }

    this.serviceRequest
      .getServiceRequestData(jobcardID)
      .subscribe((jobcard) => {
        const modalRef = this.modalService.open(UpdateJobcardComponent, {
          size: 'lg',
          backdrop: 'static',
          windowClass: 'jobcard-modal',
        });
        modalRef.componentInstance.jobcard = jobcard;
        modalRef.componentInstance.partnerID = this.partnerID;
        modalRef.result.then(
          (result) => {
            this.getData();
          },
          (err) => {
            this.getData();
          },
        );
      });
  }

  updateFilter(partner) {
    this.selectedPartnerIds = partner.map((x) => {
      return x.partnerID;
    });
    this.selectedPartners = partner;
    console.log(this.selectedPartnerIds);
    console.log(this.selectedPartners);
    this.getData();
  }
}
